import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import {
	FormControl,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	OutlinedInput,
	Select
} from "@mui/material";

export interface FilterOption {
	value: string;
	label: string;
}

interface FilterFieldsProps {
	statusValue: string;
	onStatusChange: (value: string) => void;
	statusOptions: FilterOption[];
	searchValue: string;
	onSearchChange: (value: string) => void;
	searchPlaceholder?: string;
}

export default function FilterFields({
	statusValue,
	onStatusChange,
	statusOptions,
	searchValue,
	onSearchChange,
	searchPlaceholder = "Search"
}: FilterFieldsProps) {
	return (
		<>
			<FormControl size="small" fullWidth>
				<InputLabel>Status</InputLabel>
				<Select value={statusValue} label="Status" onChange={(e) => onStatusChange(e.target.value)}>
					{statusOptions.map((option) => (
						<MenuItem key={option.value} value={option.value}>
							{option.label}
						</MenuItem>
					))}
				</Select>
			</FormControl>
			<OutlinedInput
				size="small"
				placeholder={searchPlaceholder}
				value={searchValue}
				onChange={(e) => onSearchChange(e.target.value)}
				startAdornment={
					<InputAdornment position="start">
						<SearchIcon fontSize="small" sx={{ color: "text.secondary" }} />
					</InputAdornment>
				}
				endAdornment={
					searchValue ? (
						<InputAdornment position="end">
							<IconButton size="small" onClick={() => onSearchChange("")} edge="end">
								<ClearIcon fontSize="small" />
							</IconButton>
						</InputAdornment>
					) : undefined
				}
			/>
		</>
	);
}
